if (!customElements.get('tabbed-content')) {
  class Tabs extends HTMLElement {
    constructor() {
      super();
      this.tabList = this.querySelector('[role="tablist"]');
      this.activeTab = this.tabList.querySelector('[aria-selected="true"]');
      this.isVerticalTablist = this.tabList.getAttribute('aria-orientation') === 'vertical';
      this.tabs = this.querySelectorAll('[role="tab"]');
      this.panels = this.querySelectorAll('[role="tabpanel"]');

      // If no tab is active by default, activate the first tab.
      if (!this.activeTab) {
        this.activeTab = this.tabs[0];
        this.activateTab(this.activeTab);
      }

      this.addListeners();
    }

    addListeners() {
      this.tabList.addEventListener('click', this.handleClick.bind(this));
      this.tabList.addEventListener('keydown', this.handleKeydown.bind(this));
    }

    /**
     * Handles 'click' events on the tablist.
     * @param {object} evt - Event object.
     */
    handleClick(evt) {
      if (!evt.target.matches('[role="tab"]') || evt.target === this.activeTab) return;
      this.activateTab(evt.target);
    }

    /**
     * Handles 'keydown' events on the tablist.
     * @param {object} evt - Event object.
     */
    handleKeydown(evt) {
      switch (evt.key) {
        case 'ArrowLeft':
        case 'ArrowRight':
          evt.preventDefault();
          if (!this.isVerticalTablist) {
            this.switchTabOnKeyPress(evt.key);
          }
          break;

        case 'ArrowUp':
        case 'ArrowDown':
          evt.preventDefault();
          if (this.isVerticalTablist) {
            this.switchTabOnKeyPress(evt.key);
          }
          break;

        // Activate the first tab.
        case 'Home':
          evt.preventDefault();
          this.activateTab(this.tabs[0]);
          break;

        // Activate the last tab.
        case 'End':
          evt.preventDefault();
          this.activateTab(this.tabs[this.tabs.length - 1]);
          break;
      }
    }

    /**
     * Activates the next or previous tab according to the key pressed.
     * @param {string} key - Key pressed.
     */
    switchTabOnKeyPress(key) {
      if (key === 'ArrowRight' || key === 'ArrowDown') {
        // If active tab is the last tab.
        if (this.activeTab === this.tabs[this.tabs.length - 1]) {
          // Activate first tab.
          this.activateTab(this.tabs[0]);
        } else {
          // Activate next tab.
          this.activateTab(this.activeTab.nextElementSibling);
        }
      } else if (key === 'ArrowLeft' || key === 'ArrowUp') {
        // If active tab is the first tab.
        if (this.activeTab === this.tabs[0]) {
          this.activateTab(this.tabs[this.tabs.length - 1]);
        } else {
          // Activate the previous tab.
          this.activateTab(this.activeTab.previousElementSibling);
        }
      }
    }

    /**
     * Activates a tab.
     * @param {Element} tab - Tab element (button).
     */
    activateTab(tab) {
      this.deactivateActiveTab();

      Tabs.setTabState(tab, true);
      tab.removeAttribute('tabindex');
      this.activeTab = tab;

      if (document.activeElement.matches('.tablist__tab')) {
        tab.focus();
      }
    }

    /**
     * Deactivates the currently active tab.
     */
    deactivateActiveTab() {
      Tabs.setTabState(this.activeTab, false);
      this.activeTab.setAttribute('tabindex', '-1');
      this.activeTab = null;
    }

    /**
     * Sets the active state of a tab and associated content panel.
     * @param {Element} tab - Tab element (button).
     * @param {boolean} active - Set the tab as active.
     */
    static setTabState(tab, active) {
      tab.setAttribute('aria-selected', active);

      const panelId = tab.getAttribute('aria-controls');
      document.getElementById(panelId).hidden = !active;
    }
  }

  customElements.define('tabbed-content', Tabs);
}

/* beties v9.10: Produktbeschreibung gekürzt mit „Weiterlesen“ (Handy und Computer).
   Neu: ohne feste Höhe, ohne Verlauf und ohne eigenen Scrollbereich – die Absätze nach dem Kürzungspunkt
   werden nur ausgeblendet, der erste Absatz auf 3 Zeilen gekürzt. Funktioniert damit auch in aufklappbaren Reitern.
   Der komplette Text bleibt im Seitencode (für Google & Co. vollständig lesbar). */
(() => {
  if (window.betiesReadMore) return;
  window.betiesReadMore = true;
  const style = document.createElement('style');
  style.textContent = '.beties-rm-hide{display:none!important}' +
    '.beties-rm-clamp{display:-webkit-box!important;-webkit-box-orient:vertical;-webkit-line-clamp:3;line-clamp:3;overflow:hidden}' +
    '.beties-rm-toggle{display:inline-flex;align-items:center;gap:6px;margin:10px 0 4px;padding:0;background:none;border:0;color:inherit;font:inherit;font-size:15px;text-decoration:underline;text-underline-offset:3px;cursor:pointer}' +
    '.beties-rm-toggle[hidden]{display:none}';
  document.head.append(style);

  const BLOCKS = 'p, h2, h3, h4, h5, h6, ul, ol, table, div, figure, blockquote, img, iframe, hr';
  const isHeading = (p) => {
    const text = p.textContent.trim();
    const strong = Array.from(p.querySelectorAll('strong,b')).map((s) => s.textContent).join('').trim();
    return text !== '' && strong === text;
  };
  const follows = (a, b) => Boolean(a.compareDocumentPosition(b) & Node.DOCUMENT_POSITION_FOLLOWING);

  function findCut(el) {
    const list = el.querySelector('ul, ol');
    const paras = Array.from(el.querySelectorAll('p'));
    for (const p of paras) {
      if (list && (!follows(list, p) || list.contains(p))) continue;
      if (p.textContent.trim() === '' || isHeading(p)) continue;
      return p;
    }
    return null;
  }

  function reset(el) {
    el.querySelectorAll('.beties-rm-hide, .beties-rm-clamp').forEach((n) => n.classList.remove('beties-rm-hide', 'beties-rm-clamp'));
  }

  function apply(el) {
    let button = el.nextElementSibling && el.nextElementSibling.classList.contains('beties-rm-toggle') ? el.nextElementSibling : null;
    const open = el.dataset.betiesRmOpen === '1';
    reset(el);
    const cut = findCut(el);
    const later = cut ? Array.from(el.querySelectorAll(BLOCKS)).filter((n) => n !== cut && !n.contains(cut) && !cut.contains(n) && follows(cut, n)) : [];
    const restLength = later.reduce((sum, n) => sum + n.textContent.trim().length, 0);
    if (!cut || restLength < 200) { if (button) button.hidden = true; return; }
    if (!button) {
      button = document.createElement('button');
      button.type = 'button';
      button.className = 'beties-rm-toggle';
      button.addEventListener('click', () => {
        const wasOpen = el.dataset.betiesRmOpen === '1';
        el.dataset.betiesRmOpen = wasOpen ? '0' : '1';
        apply(el);
        if (wasOpen) button.scrollIntoView({behavior: 'smooth', block: 'center'});
      });
      el.after(button);
    }
    button.hidden = false;
    button.setAttribute('aria-expanded', open ? 'true' : 'false');
    if (open) {
      button.textContent = 'Weniger anzeigen ▴';
    } else {
      cut.classList.add('beties-rm-clamp');
      later.forEach((n) => n.classList.add('beties-rm-hide'));
      button.textContent = 'Weiterlesen ▾';
    }
    const panel = el.closest('.disclosure__panel');
    if (panel && panel.style.height && panel.style.height !== 'auto') panel.style.height = '';
  }

  function init() {
    document.querySelectorAll('.product-description').forEach((el) => {
      if (el.dataset.betiesRm) return;
      el.dataset.betiesRm = '1';
      let timer;
      const run = () => { clearTimeout(timer); timer = setTimeout(() => apply(el), 30); };
      run();
      new MutationObserver(run).observe(el, {childList: true, subtree: true, characterData: true});
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once: true});
  else init();
})();